module.exports = __webpack_public_path__ + "img/icon1.4ac51f69.png";